import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import FollowUpsFormModel from "../../models/follow-ups-form";

export default class DynamicFormRepository extends BaseRepository {
  static modelClass = FollowUpsFormModel;
  modelName = "follow-ups-form";

  async query({ formUrl }) {
    if (formUrl) {
      const urlPath = formUrl.replace("/api/", "");
      return await super.query({
        urlPath: urlPath,
      });
    }
  }

  async postForm(formUrl, payload) {
    if (!formUrl) {
      throw new Error("Missing formUrl");
    }

    const urlPath = formUrl.replace("/api/", "");

    return await super.post(payload, {
      urlPath: urlPath,
    });
  }
}
